import { assistantDisplayText } from '@/lib/engage/model-cta';

/** Strip HTML and common Markdown so TTS does not read markup aloud. */
export function stripMarkupForTts(raw: string): string {
  let s = raw;
  s = s.replace(/<[^>]+>/g, ' ');
  s = s.replace(/```[\s\S]*?```/g, ' ');
  s = s.replace(/`[^`]*`/g, ' ');
  s = s.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
  s = s.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ');
  s = s.replace(/^#{1,6}\s+/gm, '');
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  s = s.replace(/\*([^*]+)\*/g, '$1');
  s = s.replace(/_{2}([^_]+)_{2}/g, '$1');
  s = s.replace(/_([^_]+)_/g, '$1');
  return s.replace(/\s+/g, ' ').trim();
}

/**
 * Visitor-facing text for auto-read TTS.
 * Must extract `response.text` from structured chat JSON before speaking —
 * never pass the raw model payload to speechSynthesis / Fish TTS.
 */
export function toTtsSpeakableText(rawAssistantMessage: string): string {
  return stripMarkupForTts(assistantDisplayText(rawAssistantMessage));
}
